import React from "react";
import { Table, Tag, Space } from "antd";
import moment from "moment";

function DataTable({ data, totals, meta, onPageChange, loading }) {
  const columns = [
    // {
    //   title: "Collection ID",
    //   dataIndex: "collection_id",
    //   key: "collection_id",
    //   width: 150,
    //   fixed: "left",
    // },
    // {
    //   title: "AWB Number",
    //   dataIndex: "airway_bill_no",
    //   key: "airway_bill_no",
    //   width: 150,
    //   fixed: "left",
    // },
    {
      title: "Box Number",
      dataIndex: "box_number",
      key: "box_number",
      width: 150,
      fixed: "left",
    },
    {
      title: "Created By",
      dataIndex: "created_user_name",
      key: "created_user_name",
      width: 200,
      render: (name, record) => {
        if (name && record.created_user_account_no) {
          return `${name} (${record.created_user_account_no})`;
        } else if (name) {
          return name;
        }
        return "-";
      },
    },
    {
      title: "Total Charge",
      dataIndex: "total_charge",
      key: "total_charge",
      width: 120,
      render: (value) => parseFloat(value || 0).toFixed(2),
      align: "right",
    },
    {
      title: "Total Paid",
      dataIndex: "total_paid",
      key: "total_paid",
      width: 120,
      render: (value) => parseFloat(value || 0).toFixed(2),
      align: "right",
    },
    {
      title: "Discount",
      dataIndex: "total_discount",
      key: "total_discount",
      width: 120,
      render: (value) => parseFloat(value || 0).toFixed(2),
      align: "right",
    },
    {
      title: "Outstanding Amount",
      dataIndex: "outstanding_amount",
      key: "outstanding_amount",
      width: 150,
      render: (value) => (
        <span style={{ fontWeight: "bold", color: "#ff4d4f" }}>
          {parseFloat(value || 0).toFixed(2)}
        </span>
      ),
      align: "right",
    },
    {
      title: "Payment Status",
      dataIndex: "paid_status",
      key: "paid_status",
      width: 120,
      render: (status) => {
        let color = status === "paid" ? "green" : status === "partial" ? "orange" : "red";
        return (
          <Tag color={color} style={{ textTransform: "uppercase" }}>
            {status}
          </Tag>
        );
      },
    },
    {
      title: "Customer Paid",
      dataIndex: "customer_paid",
      key: "customer_paid",
      width: 120,
      render: (value) => (
        <Tag color={value ? "green" : "default"}>
          {value ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 180,
      render: (date) => moment(date).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "Sender Name",
      dataIndex: "sender_name",
      key: "sender_name",
      width: 150,
    },
    {
      title: "Sender Phone",
      dataIndex: "sender_phone",
      key: "sender_phone",
      width: 130,
    },
    {
      title: "Receiver Name",
      dataIndex: "receiver_name",
      key: "receiver_name",
      width: 150,
    },
    {
      title: "Receiver Phone",
      dataIndex: "receiver_phone",
      key: "receiver_phone",
      width: 130,
    },
    {
      title: "Service Type",
      dataIndex: "service_type",
      key: "service_type",
      width: 120,
    },
    {
      title: "Branch",
      dataIndex: "branch_name",
      key: "branch_name",
      width: 150,
    },
  ];

  const pagination = {
    current: parseInt(meta.page) || 1,
    pageSize: parseInt(meta.take) || 10,
    total: parseInt(meta.itemCount) || 0,
    showSizeChanger: true,
    showTotal: (total, range) =>
      `${range[0]}-${range[1]} of ${total} items`,
    pageSizeOptions: ["10", "20", "50", "100"],
    onChange: (page, pageSize) => {
      onPageChange(page, pageSize);
    },
  };

  return (
    <div style={{ padding: "20px", background: "#fff" }}>
      {/* Totals Summary */}
      {totals && (
        <div
          style={{
            marginBottom: "20px",
            padding: "15px",
            background: "#f5f5f5",
            borderRadius: "4px",
            display: "flex",
            gap: "30px",
            flexWrap: "wrap",
          }}
        >
          <div>
            <strong>Total Unpaid Boxes:</strong>{" "}
            <span style={{ color: "#ff4d4f", fontWeight: "bold" }}>
              {totals.total_unpaid_boxes || 0}
            </span>
          </div>
          <div>
            <strong>Total Partial Boxes:</strong>{" "}
            <span style={{ color: "#fa8c16", fontWeight: "bold" }}>
              {totals.total_partial_boxes || 0}
            </span>
          </div>
          <div>
            <strong>Total Boxes:</strong>{" "}
            <span style={{ fontWeight: "bold" }}>
              {totals.total_boxes || 0}
            </span>
          </div>
        </div>
      )}

      <Table
        columns={columns}
        dataSource={data}
        rowKey="box_number"
        pagination={pagination}
        loading={loading}
        scroll={{ x: 1800 }}
        size="small"
      />
    </div>
  );
}

export default DataTable;

